module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/img (109).9d1616bb.jpg";